const GUARD_CHARS =
  "的一是在不了有和人这中大为上个国我以要他时来用们生到作地于出就分对成会可主发年动同工也能下过子说产种面而方后多定行学法所民得经十百千万金木水火土风雨云山水日月星";

const GUARD_INLINE_STYLE =
  "font-size:0;line-height:0;opacity:0;width:0;height:0;margin:0;padding:0;border:0;overflow:hidden;display:inline;pointer-events:none;";

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function hashSeed(source, index) {
  let hash = 2166136261;
  const seed = source + "\0" + index;
  for (let i = 0; i < seed.length; i++) {
    hash ^= seed.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

function segmentClass(source, index) {
  return "cg-" + (hashSeed(source, index) % 9973);
}

function guardCharAt(source, index) {
  return GUARD_CHARS.charAt(hashSeed(source, index + 7919) % GUARD_CHARS.length);
}

function shouldInsertGuard(source, index) {
  return hashSeed(source, index) % 100 > 35;
}

export function buildCopyGuardHtml(text) {
  if (text === null || text === undefined || text === "") {
    return "";
  }
  const source = String(text);
  let html = "";
  for (let i = 0; i < source.length; i++) {
    html +=
      '<span class="copy-seg ' +
      segmentClass(source, i) +
      '">' +
      escapeHtml(source.charAt(i)) +
      "</span>";
    if (shouldInsertGuard(source, i)) {
      html +=
        '<span class="copy-seg ' +
        segmentClass(source, i + 5000) +
        ' copy-seg--noise" style="' +
        GUARD_INLINE_STYLE +
        '">' +
        guardCharAt(source, i) +
        "</span>";
    }
  }
  return html;
}



// WEBPACK FOOTER //
// ./src/utils/copyGuard.js